import React from "react";
import { useDispatch } from "react-redux";

import { Action, Category } from "constants/events";
import { REQUEST_LOCATION } from "redux/reducers/location";
import { trackEvent } from "utils/trackEvent";

const LocationPickerButton = () => {
  const dispatch = useDispatch();

  const onClick = () => {
    trackEvent(Category.button, Action.click, "change your location");
    dispatch({ type: REQUEST_LOCATION });
  };

  return (
    <button className="button mt-lg lg:mt-xl" onClick={onClick}>
      change your location
    </button>
  );
};

export default LocationPickerButton;
